<template>
  <loading-charts v-if="loadingData" class="loading-charts"/>
  <div v-if="(selectedShipmentArray.length > 0)" class="button-container">
    <div class="print-selected">
        <p class="print-selected-text" @click="toggleReassignDeliveryRouteValue()">Reassign Delivery Route</p>
    </div>
  </div>
  <div class="button-container">
    <input class="search-shipments" type="text" v-model="searchTerm" placeholder="Search shipments..." />
  </div>
  <div class="table-container-main">
    <div class="responsive-table">
        <div class="table-header" id="header">
            <div class="col-1">Shipment ID</div>
            <div class="col-2">Location</div>
            <div class="col-3">Status</div>
            <div class="col-4">External ID</div>
        </div>
        <loading-charts v-if="loadingTable" class="loading-charts"/>
        <div v-if="(manifestShipmentTableData.length > 0)" class="table-row-container">
            <div class="table-row" :class="{ 'highlight-row': matchedShipmentIds.includes(shipment.shipmentID) }" :ref="matchedShipmentIds.includes(shipment.shipmentID) ? 'matchedRow' : null" v-for="(shipment, index) in manifestShipmentTableData" :key="index">

                <div v-if="shipment.externalTrackingNumber" @click="trackShipment(shipment.shipmentID)" class="col-1"><p class="shipmentid-text" id="shipmentid-text">{{shipment.shipmentID}}</p></div>
                <div v-else @click="trackShipment(shipment.shipmentID)" class="col-1"><p class="shipmentid-text" id="shipmentid-text" style="background-color: red; color: #fff;" >{{shipment.shipmentID}}</p></div>
                <div class="col-2 col-data"><span style="font-weight: bold;">{{shipment.address.companyName}}</span> {{shipment.address.address1}}, {{shipment.address.city}}, {{shipment.address.state}}, {{shipment.address.zipCode}}</div>
                <div class="col-3 col-data"><p class="service-text">{{shipment.status}}</p></div>
                <div class="col-4"><p class="service-text">{{shipment.externalTrackingNumber}}</p></div>
            </div>
        </div>
        <div v-if="(manifestShipmentTableData.length == 0)" class="table-row-container">
            <div class="table-row">
                <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                <div class="col-2 col-data">No Shipments</div>
                <div class="col-3 col-data"><p class="service-text"></p></div>
                <div class="col-4"></div>
            </div>
        </div>
    </div>
  </div>
  <div class="button-container">
    <div class="print-selected close-label">
        <p class="print-selected-text download-csv" @click="downloadCSVTest()">Download CSV</p>
    </div>
  </div>
  
<shipment-info v-if="toggleTrackShipment" @closeShipmentInfo="closeShipmentInfo($event)" :trackShipmentID="trackShipmentID" :cognitoUser="cognitoUser" :jwtToken="jwtToken" :userData="userData"/>
<alert-user  v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import ShipmentInfo from './../ShipmentInfo.vue'
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue'
import AlertUser from '../../Popups/AlertUser.vue';
import jsonexport from 'jsonexport'

export default {
    components:{
        ShipmentInfo,
        LoadingCharts,
        AlertUser
    },
    props: ['p2pManifestID', 'manifestTripSheetID', 'selectedShipment', 'userData', 'jwtToken', 'cognitoUser', 'manifestShipmentTableData'],
    data(){
        return{
            trackShipmentID: null,
            toggleTrackShipment: false,
            user: null,
            loadingData: false,
            loadingTable: false,
            isFiltered: false,
            filterField: '',
            filterValue: '',
            toggleAlertBox: '',
            alertMessage: '',
            selectedShipmentArray: [],
            toggleReassignDeliveryRoute: false,
            searchTerm: ''
        }
    },
    watch: {
        matchedShipmentIds(newVal) {
            if (newVal.length >= 1) {
            this.$nextTick(() => {
                const firstMatchedEl = this.$refs.matchedRow?.[0];
                if (firstMatchedEl && typeof firstMatchedEl.scrollIntoView === 'function') {
                firstMatchedEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
            }
        }
    },
    computed: {
        matchedShipmentIds() {
            const search = this.searchTerm.toLowerCase();
            if (!this.searchTerm || this.searchTerm.length < 3) {
                return [];
            }

            return this.manifestShipmentTableData
            .filter(shipment => {
                const containsValue = obj => {
                for (const key in obj) {
                    const value = obj[key];
                    if (value && typeof value === 'object') {
                    if (containsValue(value)) return true;
                    } else {
                    if (String(value).toLowerCase().includes(search)) return true;
                    }
                }
                return false;
                };
                return containsValue(shipment);
            })
            .map(shipment => shipment.shipmentID);
        }
    },
    methods:{
        closeReassignRoutePopUp(event){
            this.toggleReassignDeliveryRoute = event;
            this.$emit('refreshManifestTable', true)
        },
        toggleReassignDeliveryRouteValue(){
            this.toggleReassignDeliveryRoute = !this.toggleReassignDeliveryRoute
        },
        trackShipment(shipmentID){
            this.toggleTrackShipment = true;
            this.trackShipmentID = shipmentID;
        },
        closeShipmentInfo(event){
            this.toggleTrackShipment = event;
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async downloadCSVTest(){
            this.loadingTable = true;
            let csvArray;

            csvArray = this.manifestShipmentTableData.map(obj =>{
                return {
                    shipmentID: obj.shipmentID,
                    route: obj.route,
                    DeliveryCompanyName: obj.address.companyName,
                    DeliveryAddress1: obj.address.address1,
                    DeliveryAddress2: obj.address.address2,
                    DeliveryCity: obj.address.city,
                    DeliveryState: obj.address.state,
                    DeliveryZipCode: obj.address.zipCode,
                    ExternalTrackingNumber: obj.externalTrackingNumber ?? "ERROR",
                    P2PManifestID: this.p2pManifestID ?? "ERROR",
                    LREXTripSheetID: this.manifestTripSheetID ?? "ERROR"
                }
            })
            jsonexport(csvArray, (error, csv) => {
                if (error) {
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error downloading manifest shipments"
                }
                const blob = new Blob([csv], { type: 'text/csv' });
                const anchor = document.createElement('a');
                anchor.href = window.URL.createObjectURL(blob);
                anchor.download = 'ManifestShipments.csv';
                anchor.click();
                window.URL.revokeObjectURL(anchor.href);
                anchor.remove();
                this.loadingTable = false;
            })
        }
    }
}
</script>

<style scoped>
.table-container-main {
	width: 100%;
	margin-top: 0;
	overflow-x: hidden;
	resize: both;
	height: 350px
}

.responsive-table {
	width: 100%
}

* {
	scrollbar-width: auto;
	scrollbar-color: #f3f3f3 #fff
}

::-webkit-scrollbar {
	width: 16px
}

::-webkit-scrollbar-track {
	background: #fff
}

::-webkit-scrollbar-thumb {
	background-color: #f3f3f3;
	border-radius: 10px;
	border: 3px solid #fff
}

.table-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #32ccfe;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px;
	color: #fff;
	position: sticky;
	top: 0
}

.table-row-container {
	height: 100%;
	overflow-y: auto;
	border-radius: 5px;
	width: 100%;
	animation: animate-table-row 1s ease
}

@keyframes animate-table-row {
	from {
		margin-left: -50px
	}

	to {
		margin-left: 0
	}
}

.table-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #f3f3f3;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px
}

.highlight-row {
  background-color: #b9b9b9 !important;
  transition: background-color 0.5s ease-in-out;
}

.table-header .col-1 {
	margin-right: 5px
}

.col-1 {
	flex-basis: 20%;
	text-align: left;
	white-space: nowrap
}

.col-2 {
	flex-basis: 40%;
	text-align: left;
	margin-left: 5px
}

.col-3 {
	flex-basis: 10%;
	text-align: left;
	margin-left: 5px
}

.col-data {
	text-align: left
}

.col-4 {
	flex-basis: 25%;
	display: flex;
	justify-content: flex-end;
	align-items: center;
    flex-wrap: wrap;
    word-break: break-word;
    overflow-wrap: break-word;
}

.col-4 p{
    margin-left: 2px;
    font-size: .6rem;
}

.col-5{
    flex-basis: 5%;
    display: flex;
	justify-content: flex-end;
}

.service-text {
	background-color: #d4d4d4;
	padding: 2.5px 10px;
	border-radius: 999px;
	width: fit-content;
	margin: 0;
	font-size: 12px
}

.shipmentid-text {
	margin: 0;
	color: #6a6a6a;
	width: fit-content;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.shipmentid-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

input[type=checkbox] {
	-webkit-appearance: none;
	appearance: none;
	background-color: #fff;
	margin: 0;
	cursor: pointer;
	font: inherit;
	color: #33f18a;
	width: 1.05em;
	height: 1.05em;
	border: .15em solid #33f18a;
	border-radius: .15em;
	display: grid;
	place-content: center;
	transition-duration: .5s
}

input[type=checkbox]:hover {
	background-color: #f3f3f3;
	transition-duration: .5s
}

input[type=checkbox]::before {
	content: "";
	width: .65em;
	height: .65em;
	clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0, 43% 62%);
	transform: scale(0);
	transform-origin: bottom left;
	transition: 120ms transform ease-in-out;
	box-shadow: inset 1em 1em var(--form-control-color);
	background-color: CanvasText
}

input[type=checkbox]:checked::before {
	transform: scale(1)
}

.search-shipments{
    border: 1px solid #e2e2e2;
    padding: 5px;
    border-radius: 25px;
    box-shadow: rgba(0, 0, 0, .05) 0 5px 15px;
    outline: 0;
    margin-bottom: 5px;
}

.button-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	margin: 0;
	animation: animate-table-row 1s ease
}

.print-selected-text {
	margin: 0;
	margin-bottom: 5px;
	margin-right: 5px;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.download-csv {
	margin-top: 5px
}

.void-selected-text {
	margin: 0;
	margin-bottom: 5px;
	padding: 2.5px 10px;
	margin-bottom: 5px;
	border-radius: 999px;
	background-color: #fe804d;
	border: 1px solid #ff5512;
	color: #fff;
	transition-duration: .5s
}

.print-selected-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.void-selected-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.close-label {
	margin-left: auto
}

.label-container {
	width: 100%
}

@media only screen and (max-width:600px) {
	.service-text {
		font-size: 8px
	}

    .col-1 {
		min-width: 30%
	}
}

/* @media only screen and (max-width:1135px) {
	.col-1 {
		min-width: 30%
	}
} */
</style>